import { pricingRuleController } from "./PricingRules/pricingRuleController";
import { message, Modal } from "antd";
import { v4 as uuidv4 } from "uuid";
import NotFoundImg from "../../../assets/images/NotFoundImg.svg";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import db from "../../../database";
import dayjs from "dayjs";
import sumBy from "lodash/sumBy";
import { stock } from "./stock";
import { discardGiftCard, discardCouponService } from "../../../services";
import { numberToWords } from "../../../utils/numberToWords";
import { clock, timeStamp, timeValidator, currentDay, dateValidator } from "../../../utils/clock";
import messages from "../../../errors/messages.en-IN.json";
import { roundTo, truncateToPrecision, applyCurrencyRounding, getRoundingMethod } from "../../../utils/tillHelpers";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useCartStore from "../../../stores/useCartStore";
import useTransactionStore from "../../../stores/useTransactionStore";
import useRestaurantStore from "../../../stores/useRestaurantStore";
import { getPricingRules, findPricingRuleById } from "../../../utils/pricingRulesCache";
import { getIsInterState } from "../../../utils/taxUtils";
import { groupItemsByTaxRate } from "./utils/taxCalculations";

export const addProductToCart = async (
  addToCart,
  qty,
  totalQtyFlag,
  cart,
  setCart,
  setSelectedProductInCart,
  deleteCart,
  processTotalManualDiscount,
  setLoader,
  salesRepresentDefaultLine,
  tillData,
  cartRef,
  productsCopy,
  salesRepresent,
  orderType,
  processBillDiscounts,
  modifiedPrice,
  setSelectedRowKeys,
  setOrderTimeDetails,
  setDisplayAddOnSelection,
  displayAddOnSelection,
  handleAddOnModal,
  manualDiscountTypes,
  CheckoutFlatDiscount,
  CheckoutPercentageDiscount,
  CheckoutTotalManualDiscount,
  setProductStock,
  selectedProductInCart,
  setTableCards,
  dispatchItemSelection,
  searchInputRef,
  deleteProductInCart,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  TotalBillDiscount,
  tillLayout,
  quantityChange,
  setManualDiscountInput,
  setSelectedManualDiscountTypeValue,
  removeAllDiscounts,
  setSelectedPaymentMethod,
  selectedReturnType,
  customMixHandler,
  setProductBOMStock,
  setProductBOMStockData
) => {
  const returnThisReceipt = useTransactionStore.getState().returnThisReceipt;
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE" && !returnThisReceipt;
  const weight = parseFloat(qty);
  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const layAwayFlag = useCartStore.getState().cart?.layAway || "N";
  const posConfig = usePOSConfigStore.getState().posConfig;
  const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
  const liveCart = useCartStore.getState().cart || cart;
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  // let addedToCart = cart.items;
  const returnEnabled = receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true;
  // Read latest cart from Zustand (source of truth), not localStorage (stale mirror).
  // Deep-copy so mutations (unshift, property updates) don't corrupt Zustand's internal state.
  const activeCartFromStore = isExchange && !returnThisReceipt ? useCartStore.getState().exchangeCart || {} : useCartStore.getState().cart || cart;
  const activeCartFromStorage = JSON.parse(JSON.stringify(activeCartFromStore));
  let addedToCart = activeCartFromStorage.items || [];
  const itemsSnapshot = JSON.parse(JSON.stringify(addedToCart));
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  taxIncludeFlag = addToCart.taxFlag === "Y" ? "N" : taxIncludeFlag;
  const isWalletReturn = receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true;
  let expiryDiscount = useTransactionStore.getState().expiryDiscount === "Y";
  let deferredMsg = null;
  let deferredPoleDisplay = null;
  const cancelledItems = addedToCart.filter((p) => p.isCanceled === "Y");
  if (cancelledItems.length > 0) {
  }
  let index = addedToCart.findIndex(
    (p) =>
      p.productId === addToCart.productId &&
      (p.upc || "") === (addToCart.upc || "") &&
      p.mBatchId === addToCart.mBatchId &&
      p.uom === addToCart.uom &&
      p.isReturn === false &&
      // BUG-1610: must NOT match a cancelled line — matching it here restores/mutates the
      // cancelled record in place, erasing cancellation history from the cart (see the now-dead
      // isCanceled==="Y" restore branch below). Re-adding a cancelled product must fall through
      // to the "new line" branch instead, so the cancelled line stays visible and a fresh, distinct
      // active line is created. See project_bug1610_canceled_item_history_lost memory for the trace.
      p.order !== "Y" &&
      !expiryDiscount &&
      !p.discountType &&
      !p.discountName &&
      p?.selectedAddons?.length <= 0
  );
  let weightFlag = false;
  let groupChildFlag = false;
  let groupParentFlag = false;
  let isNewLineAdded = false;

  if (expiryDiscount === true || addToCart?.modified) {
    index = addedToCart.findIndex(
      (p) =>
        p.productId === addToCart.productId &&
        (p.upc || "") === (addToCart.upc || "") &&
        p.mBatchId === addToCart.mBatchId &&
        p.isReturn === false &&
        (expiryDiscount || addToCart?.modified) &&
        p.lineId === addToCart.lineId
    );
  }

  if (addedToCart[index]?.selectedAddons?.length > 0) {
    index = -1;
  }

  if (addedToCart[index]?.newCustomAttributes?.length > 0) {
    index = -1;
  }

  if (addToCart?.selectedAddons?.length > 0) {
    index = addedToCart.findIndex(
      (p) =>
        p.productId === addToCart.productId &&
        p.upc === addToCart.upc &&
        p.mBatchId === addToCart.mBatchId &&
        // p.isReturn === false &&
        p.lineId === addToCart.lineId &&
        p?.selectedAddons?.length > 0 &&
        p?.selectedAddons?.length === addToCart?.selectedAddons?.length
    );

    let indexFlag = true;
    addedToCart[index]?.selectedAddons?.forEach((addOn) => {
      // Compare with addToCart product add-ons
      let matchedAddOn = addToCart?.selectedAddons?.some((addOnItem) => {
        // return addOn.mProductAddOnId === addOnItem.mProductAddOnId;
        if (addOn.mProductAddOnId === addOnItem.mProductAddOnId) {
          addOn.weight = (addOn.weight ?? 0) + weight;
          return true;
        }
        return false;
      });

      // If there is no matching add-on, set flag to false
      if (!matchedAddOn) {
        indexFlag = false;
      }
    });
    if (!indexFlag) {
      index = -1;
    }
  } else if (addToCart?.productAddons?.length > 0) {
    index = addedToCart.findIndex(
      (p) =>
        p.productId === addToCart.productId &&
        p.upc === addToCart.upc &&
        p.mBatchId === addToCart.mBatchId &&
        // p.isReturn === false &&
        p.lineId === addToCart.lineId
      // p?.selectedAddons?.length > 0 &&
      // p?.selectedAddons?.length === addToCart?.selectedAddons?.length
    );
  }

  if (addToCart?.newCustomAttributes?.length > 0) {
    index = addedToCart.findIndex(
      (p) =>
        p.productId === addToCart.productId &&
        p.upc === addToCart.upc &&
        p.mBatchId === addToCart.mBatchId &&
        p.isReturn === false &&
        p.lineId === addToCart.lineId &&
        p?.newCustomAttributes?.length > 0
    );
  }

  if (addToCart.isGiftCard === true) {
    index = addedToCart.findIndex((p) => p.productId === addToCart.productId && p.upc === addToCart.upc && p.lineId === addToCart.lineId);
  }

  if (addToCart.discountType || addToCart.discountName) {
    index = addedToCart.findIndex(
      (p) =>
        p.productId === addToCart.productId &&
        p.upc === addToCart.upc &&
        p.mBatchId === addToCart.mBatchId &&
        p.isReturn === false &&
        !expiryDiscount &&
        p.lineId === addToCart.lineId
    );
  }

  if (deleteProductInCart && index < 0 && addToCart.lineId) {
    index = addedToCart.findIndex((p) => p.lineId === addToCart.lineId && p.productId === addToCart.productId);
  }

  if (addToCart.discount <= 0) {
    delete addToCart.priority;
  }

  if (addToCart.addNewLine === "Y" && !deleteProductInCart && !quantityChange && !addToCart?.modified) {
    index = -1;
  }

  if (addToCart.productSegment === "CB" && (!addToCart.childItems || addToCart.childItems.length <= 0) && !deleteProductInCart) {
    // Open popup to select child items
    localStorage.setItem("productSegment", "CB");
    const itemsToDispatch = addToCart || [];
    localStorage.removeItem("productName");
    const { selectedItems = [] } = await new Promise((resolve) => {
      dispatchItemSelection(itemsToDispatch, cart, setCart, setProductStock, setShowCompleteSaleStock, setCompleteSaleStockData, (eventData) => {
        resolve({ selectedItems: eventData?.selectedItems || [] });
      });
    });
    localStorage.removeItem("productSegment");
    // Assign selected child items
    addToCart.childItems = selectedItems;
  }

  if (addToCart?.companion === "Y" && (!addToCart.children || addToCart.children.length <= 0)) {
    // Open popup to select child items
    localStorage.setItem("productSegment", "CP");
    const itemsToDispatch = addToCart || [];
    localStorage.removeItem("productName");
    const { selectedItems = [] } = await new Promise((resolve) => {
      dispatchItemSelection(itemsToDispatch, cart, setCart, setProductStock, setShowCompleteSaleStock, setCompleteSaleStockData, (eventData) => {
        resolve({ selectedItems: eventData?.selectedItems || [] });
      });
    });
    localStorage.removeItem("productSegment");
    // Assign selected child items
    addToCart.children = selectedItems;
  }

  if (addToCart?.groupedItems === true) {
    let cartObj = { ...cart };
    let selectedIndex;
    let items = cartObj?.items?.map((item, index) => {
      if (item?.children) {
        const updatedChildren = item.children.map((child) => {
          if (child.lineId === addToCart?.lineId) {
            selectedIndex = index;
            groupChildFlag = true;
            const stdTax = child.sunitprice * (1 + child.taxRate / 100);
            const grossStd = taxIncludeFlag === "Y" ? child.sunitprice : roundTo(stdTax, precision);
            const newQty = totalQtyFlag ? weight : addToCart?.weight + weight;
            const sp = parseFloat(child.sunitprice);
            const mrp = sp * newQty;
            const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + child.taxRate / 100) : (mrp * child.taxRate) / 100;
            const saleprice = (taxIncludeFlag === "Y" ? mrp : mrp + tax) - tax;
            const childnettotal = parseFloat(parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax).toFixed(precision));
            const unitPrice = isFinite(childnettotal / newQty) ? (taxIncludeFlag === "Y" ? childnettotal / newQty / (1 + item.taxRate / 100) : saleprice) : 0;
            return {
              ...child,
              weight: newQty,
              actualWeight: newQty,
              baseQty: newQty,
              linestd: roundTo(grossStd * newQty, precision),
              linegross: parseFloat(parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax).toFixed(precision)),
              linenet: childnettotal ? parseFloat(parseFloat(childnettotal - tax).toFixed(precision)) : 0,
              // netunit: childnettotal ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
              salePrice: saleprice,
              // linestd: truncateToPrecision(grossStd * newQty, precision),
              // actualWeight: parseFloat((addToCart?.weight + weight / item?.weight).toFixed(2)),
            };
          }
          return child;
        });
        return {
          ...item,
          children: updatedChildren,
        };
      }
      return item;
    });
    addToCart = items[selectedIndex];
    addToCart?.children.forEach((childItem) => {
      // childItem.weight += weight;
      // let newWeight = totalQtyFlag
      //   ? parseFloat(truncateToPrecision(childItem.weight)) * parseFloat(truncateToPrecision(weight))
      //   : parseFloat(childItem.actualWeight * (selectedProductInCart.weight + weight));
      // childItem.weight = newWeight;
      const sp = parseFloat(childItem.sunitprice);
      const mrp = sp * childItem.weight;

      const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + childItem.taxRate / 100) : (mrp * childItem.taxRate) / 100;

      childItem.taxAmount = roundTo(tax, precision);
      childItem.nettotal = taxIncludeFlag === "Y" ? parseFloat(parseFloat(mrp).toFixed(precision)) : roundTo(mrp + tax, precision);
    });

    // Aggregate tax and net total from children
    const totalTax = sumBy(addToCart.children, "taxAmount");
    const totalNet = sumBy(addToCart.children, "nettotal");

    addToCart.taxAmount = totalTax;
    addToCart.nettotal = totalNet;

    index = addedToCart.findIndex(
      (p) =>
        p.lineId === addToCart.lineId &&
        p.upc === addToCart.upc &&
        p.mBatchId === addToCart.mBatchId &&
        p.isReturn === false &&
        !expiryDiscount &&
        !p.discountType &&
        p?.selectedAddons?.length <= 0
    );

    addedToCart[index] = {
      ...addedToCart[index],
      ...addToCart,
      children: [...addToCart.children],
    };
  } else {
    if (addToCart?.children && addToCart?.children.length > 0 && addToCart.companion !== "Y") {
      addToCart?.children.forEach((childItem) => {
        // childItem.weight += weight;
        // let newWeight = totalQtyFlag
        //   ? parseFloat(truncateToPrecision(childItem.actualWeight)) * parseFloat(truncateToPrecision(weight))
        //   : parseFloat(childItem.actualWeight * ((selectedProductInCart.weight || addToCart.weight) + weight));
        let newWeight = totalQtyFlag
          ? parseFloat(truncateToPrecision(childItem.baseQty)) * parseFloat(truncateToPrecision(weight))
          : parseFloat(childItem.actualWeight * ((selectedProductInCart.weight || addToCart.weight) + weight));
        const stdTax = childItem.sunitprice * (1 + childItem.taxRate / 100);
        const grossStd = taxIncludeFlag === "Y" ? childItem.sunitprice : parseFloat(parseFloat(stdTax).toFixed(precision));
        childItem.weight = newWeight;
        // childItem.linestd = truncateToPrecision(grossStd * newWeight, precision);
        childItem.linestd = grossStd * newWeight;
        const sp = parseFloat(childItem.sunitprice);
        const mrp = sp * childItem.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + childItem.taxRate / 100) : (mrp * childItem.taxRate) / 100;
        const childnettotal = parseFloat(parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax).toFixed(precision));
        ((childItem.linegross = childnettotal), (childItem.linenet = childnettotal ? parseFloat(parseFloat(childnettotal - tax).toFixed(precision)) : 0));
        childItem.taxAmount = tax;
        childItem.nettotal = childnettotal;
      });

      // Aggregate tax and net total from children
      const totalTax = sumBy(addToCart.children, "taxAmount");
      const totalNet = sumBy(addToCart.children, "nettotal");

      addToCart.taxAmount = totalTax;
      addToCart.nettotal = totalNet;

      addedToCart[index] = {
        ...addedToCart[index],
        ...addToCart,
        children: [...addToCart.children],
      };
      groupParentFlag = true;
    }
  }
  if (addToCart.childItems && addToCart.childItems.length > 0) {
    const updatedChildItems = addToCart.childItems.map((childItem) => {
      const sp = parseFloat(childItem.sunitprice);
      const mrp = sp * childItem.weight;
      const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + childItem.taxRate / 100) : (mrp * childItem.taxRate) / 100;
      const newWeight = totalQtyFlag
        ? parseFloat(truncateToPrecision(childItem.rawWeight)) * parseFloat(truncateToPrecision(weight))
        : parseFloat(childItem?.rawWeight * ((selectedProductInCart.weight || addToCart.weight) + weight));
      const nettotal = parseFloat((taxIncludeFlag === "Y" ? mrp : mrp + tax).toFixed(precision));

      return {
        ...childItem,
        taxAmount: tax,
        weight: newWeight,
        nettotal,
      };
    });

    // Update addToCart values
    addToCart.childItems = updatedChildItems;
    addToCart.salePrice = updatedChildItems.reduce((total, child) => {
      const sp = parseFloat(child.sunitprice);
      const mrp = sp * child.weight;
      const tax = child.taxAmount;
      return total + (taxIncludeFlag === "Y" ? mrp : mrp + tax) - tax;
    }, 0);

    addToCart.sunitprice = addToCart.salePrice;
    addToCart.realPrice = addToCart.salePrice;
    addToCart.originalPrice = addToCart.salePrice;

    if (index >= 0) {
      addedToCart[index] = {
        ...addedToCart[index],
        ...addToCart,
        childItems: [...updatedChildItems],
      };
    }
  }

  if (index >= 0 && !addedToCart?.[index]?.parkedItem && !addedToCart?.[index]?.discountType) {
    const isQtyDecimal = addToCart.isQtyDesimal;
    let newWeight = totalQtyFlag ? parseFloat(weight) : parseFloat(addedToCart[index].weight) + parseFloat(weight);
    // Round to UOM precision so 1 + 1.22 doesn't become 2.2200000000000002 in
    // the cell (issue #12). Prefer the UOM stdprecision when present, falling
    // back to currency precision so we don't accidentally truncate decimal-by-
    // weight items more aggressively than they're priced.
    const qtyPrecision = parseInt(addToCart?.uomData?.[0]?.stdprecision, 10);
    const roundPrec = !isNaN(qtyPrecision) ? qtyPrecision : precision;
    if (Number.isFinite(newWeight)) {
      newWeight = parseFloat(newWeight.toFixed(roundPrec));
    }

    if (groupChildFlag === false) {
      addedToCart[index].weight = newWeight;
      addToCart.weight = newWeight;
    }

    if (parseFloat(addedToCart[index].weight) <= 0) {
      weightFlag = true;
      setSelectedProductInCart({});
      let setAuthTokens;

      if (addToCart.isGiftCard || addedToCart[index]?.iscoupon) {
        const authHeaders = await getOAuthHeaders();
        if (authHeaders && authHeaders.access_token) {
          setAuthTokens = authHeaders.access_token;
        }
      }

      if (addedToCart[index]?.iscoupon) {
        await discardCouponService(addedToCart[index].couponInput, addedToCart[index].referenceId);
        // const discardCoupon = {
        //   query: `query{
        //       discardCoupon(couponcode:"${addedToCart[index].couponInput}",referenceId: "${addedToCart[index].referenceId}"){
        //           status
        //           message
        //       }
        //   }`,
        // };
        // Axios({
        //   url: serverUrl,
        //   method: "POST",
        //   data: discardCoupon,
        //   headers: {
        //     "Content-Type": "Application/json",
        //     Authorization: `${setAuthTokens}`,
        //   },
        // });
      }
      if (cart.couponInput?.length > 0) {
        cart.couponInput = cart.couponInput?.filter((coupon) => {
          if (addedToCart[index].couponInput !== coupon) {
            return coupon;
          }
        });
      }

      // if (addToCart.selectedAddons.length > 0) {
      //   checkAndShowAddOnModal(addToCart.selectedAddons);
      // }

      if (addToCart.isGiftCard) {
        let giftCardDataIndex = cart?.giftCardData?.findIndex((giftCard) => giftCard.number === addToCart.cardNo);
        // const discardGiftCard = {
        //   query: `mutation{
        //             discardGiftCard(giftCards: [{cardNo: "${cart.giftCardData[giftCardDataIndex].number}" , referenceNo : "${cart.giftCardData[giftCardDataIndex].refId}"}]){
        //               status
        //               message
        //       }
        //   }`,
        // };
        // Axios({
        //   url: serverUrl,
        //   method: "POST",
        //   data: discardGiftCard,
        //   headers: {
        //     "Content-Type": "Application/json",
        //     Authorization: `${setAuthTokens}`,
        //   },
        // }).then((res) => {
        //   cart.giftCardData.splice(giftCardDataIndex, 1);
        // });
        try {
          await discardGiftCard(activeCartFromStorage.giftCardData[giftCardDataIndex].number, activeCartFromStorage.giftCardData[giftCardDataIndex].refId);

          // Remove the gift card via filter on the deep-copy — avoids mutating Zustand state directly
          activeCartFromStorage.giftCardData = activeCartFromStorage.giftCardData.filter((_, i) => i !== giftCardDataIndex);
        } catch (error) {
          console.error("Error discarding gift card:", error);
          message.error(`${messages.errors.cart.gift_card_discard_failed}`);
        }
      }
      message.warning(`${addToCart.name} ${messages.errors.cart.removed_successfully}`, 0.1);
      if (cart.advancePayment <= 0 || !cart.advancePayment) {
        if (cart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
          cart.manualDiscountData.lineLevelDiscount = cart.manualDiscountData.lineLevelDiscount.filter((lineItem) => lineItem.productId !== addedToCart[index].productId);
        }
        addedToCart.splice(index, 1);
      } else {
        addedToCart[index].nettotal = 0;
        addedToCart[index].unitTax = 0;
        addedToCart[index].netStd = 0;
      }
    } else {
      let manualDiscountInput = 0;
      if (addedToCart[index].discountType === "PD") {
        manualDiscountInput = addedToCart[index].discountValue;
      }
      const discountAmt = (parseFloat(manualDiscountInput) / 100) * parseFloat(addedToCart[index].realPrice);
      addedToCart[index].discount = totalQtyFlag ? discountAmt * weight : discountAmt * addedToCart[index].weight;
      //const addOnsNewProduct = sumBy(addedToCart?.selectedAddons, "price");
      const addOnsPriceSum = sumBy(addedToCart[index]?.selectedAddons, "price");
      const sp = parseFloat(addedToCart[index].realPrice) + addOnsPriceSum - discountAmt;
      //let mrp = totalQtyFlag ? parseFloat(sp) * weight : parseFloat(sp) * addedToCart[index].weight;
      //const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart[index].taxRate / 100) : (mrp * addedToCart[index].taxRate) / 100;
      if (groupChildFlag === false && groupParentFlag === false) {
        const factor = Math.pow(10, precision);
        const qty = addedToCart[index].weight;
        const unitTax = taxIncludeFlag === "Y" ? sp - sp / (1 + addedToCart[index].taxRate / 100) : (sp * addedToCart[index].taxRate) / 100;

        const unitMrp = sp;
        const roundedUnitTax = Math.round((unitTax + Number.EPSILON) * factor) / factor;
        const roundedUnitMrp = Math.round((unitMrp + Number.EPSILON) * factor) / factor;

        addedToCart[index].taxAmount = roundedUnitTax * qty;
        addedToCart[index].nettotal = taxIncludeFlag === "Y" ? roundedUnitMrp * qty : (roundedUnitMrp + roundedUnitTax) * qty;
      }
      addedToCart[index].modified = addToCart?.modified ? true : false;
      delete addedToCart[index].nextRule;
      if (addedToCart[index].discount <= 0) {
        delete addedToCart[index].priority;
      }
      deferredMsg = {
        type: qty < 0 ? "warning" : "success",
        text: `${addToCart.name} ${qty < 0 ? `${messages.errors.cart.removed_successfully}` : `${messages.errors.cart.added_successfully}`}`,
      };
    }
  } else if (index >= 0 && !addedToCart?.[index]?.parkedItem && addedToCart?.[index]?.discountType) {
    if (groupChildFlag === false) {
      addedToCart[index].weight = totalQtyFlag
        ? parseFloat(truncateToPrecision(weight, addToCart.isQtyDesimal))
        : parseFloat(truncateToPrecision(addedToCart[index].weight, addToCart.isQtyDesimal)) + parseFloat(parseFloat(truncateToPrecision(weight, addToCart.isQtyDesimal)));
      addToCart.weight = parseFloat(truncateToPrecision(addedToCart[index].weight, addToCart.isQtyDesimal));
    }
    if (parseFloat(addedToCart[index].weight) === 0) {
      setSelectedProductInCart({});
      message.warning(`${addToCart.name} ${messages.errors.cart.removed_successfully}`, 0.1);
      if (cart.advancePayment <= 0) {
        if (cart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
          cart.manualDiscountData.lineLevelDiscount = cart.manualDiscountData.lineLevelDiscount.filter((lineItem) => lineItem.productId !== addedToCart[index].productId);
        }
        addedToCart.splice(index, 1);
      } else {
        addedToCart[index].nettotal = 0;
        addedToCart[index].unitTax = 0;
        addedToCart[index].netStd = 0;
        addedToCart[index].salePrice = 0;
      }
    } else {
      let manualDiscountInput = 0;
      if (addedToCart[index].discountType === "PD") {
        manualDiscountInput = addedToCart[index].discountValue;
      }
      const discountAmt = (parseFloat(manualDiscountInput) / 100) * parseFloat(addedToCart[index].realPrice);
      addedToCart[index].discount = totalQtyFlag ? discountAmt * weight : discountAmt * addedToCart[index].weight;
      const addOnsPriceSum = sumBy(addedToCart[index]?.selectedAddons, "price");
      const sp = parseFloat(addedToCart[index].realPrice) + addOnsPriceSum - discountAmt;
      if (groupChildFlag === false && groupParentFlag === false) {
        const factor = Math.pow(10, precision);
        const qty = addedToCart[index].weight;
        const unitTax = taxIncludeFlag === "Y" ? sp - sp / (1 + addedToCart[index].taxRate / 100) : (sp * addedToCart[index].taxRate) / 100;
        const unitMrp = sp;
        const roundedUnitTax = Math.round((unitTax + Number.EPSILON) * factor) / factor;
        const roundedUnitMrp = Math.round((unitMrp + Number.EPSILON) * factor) / factor;

        addedToCart[index].taxAmount = roundedUnitTax * qty;
        addedToCart[index].nettotal = taxIncludeFlag === "Y" ? roundedUnitMrp * qty : (roundedUnitMrp + roundedUnitTax) * qty;
      }
      addedToCart[index].modified = addToCart?.modified ? true : false;
      delete addedToCart[index].nextRule;
      if (addedToCart[index].discount <= 0) {
        delete addedToCart[index].priority;
      }
      deferredMsg = {
        type: qty < 0 ? "warning" : "success",
        text: `${addToCart.name} ${qty < 0 ? `${messages.errors.cart.removed_successfully}` : `${messages.errors.cart.added_successfully}`}`,
      };
    }
  } else if (index >= 0 && addedToCart?.[index]?.parkedItem) {
    if (addedToCart[index].isCanceled === "Y") {
      addedToCart[index].isCanceled = "N";
      addedToCart[index].order = "N";
      addedToCart[index].firedQty = 0;
      addedToCart[index].weight = parseFloat(weight);
      addedToCart[index].sendQty = parseFloat(weight);
      addedToCart[index].update = "N";
      const addOnsPriceSum = sumBy(addedToCart[index]?.selectedAddons, "price") || 0;
      // Fall back to salePrice if realPrice is missing — avoids NaN propagating into nettotal/grossunit/subTotal.
      const sp = parseFloat(addedToCart[index].realPrice ?? addedToCart[index].salePrice) + addOnsPriceSum;
      const mrp = sp * addedToCart[index].weight;
      const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart[index].taxRate / 100) : (mrp * addedToCart[index].taxRate) / 100;
      addedToCart[index].taxAmount = parseFloat(parseFloat(tax).toFixed(precision));
      addedToCart[index].nettotal = taxIncludeFlag === "Y" ? parseFloat(mrp.toFixed(precision)) : parseFloat((mrp + tax).toFixed(precision));
      addedToCart[index].discount = 0;
      addToCart = { ...addedToCart[index] };
      deferredMsg = { type: "success", text: `${addedToCart[index].name} ${messages.errors.cart.added_successfully}` };

      // Persist the restoration to fbOrderData (cart.items + wsData.items), mirroring the DB-write
      // pattern used by the non-cancelled parked-item branch below. Without this, reselecting this
      // table (handleExistingOrder) rebuilds the cart from the stale wsData snapshot, which still
      // marks this line isCanceled:"Y", silently re-cancelling the just-restored item. (BUG-1504)
      try {
        const allFbOrdersRestore = await db.fbOrderData.toArray();
        const matchingOrderRestore = allFbOrdersRestore.find((order) => order.cart?.sOrderID === cart.sOrderID && order.table === cart.tableNo);
        if (matchingOrderRestore) {
          const restoredLineId = addedToCart[index].lineId;
          const restoredFbOrderLineId = addedToCart[index].fbOrderLineId;
          const updatedItemsRestore = (matchingOrderRestore.cart?.items || []).map((item) =>
            item.lineId === restoredLineId ? { ...addedToCart[index] } : item
          );
          const hasWsData = matchingOrderRestore.wsData && Object.keys(matchingOrderRestore.wsData).length > 0;
          const updatedOrderRestore = {
            ...matchingOrderRestore,
            cart: { ...matchingOrderRestore.cart, items: updatedItemsRestore },
          };
          if (hasWsData) {
            updatedOrderRestore.wsData = {
              ...matchingOrderRestore.wsData,
              items: (matchingOrderRestore.wsData.items || []).map((item) =>
                item.fbOrderLineId === restoredFbOrderLineId ? { ...item, isCanceled: "N", orderStatus: "OR" } : item
              ),
            };
          }
          await db.fbOrderData.put(updatedOrderRestore);
        }
      } catch (error) {
        console.error("[BUG-1504] Error persisting restored item to fbOrderData:", error);
      }
    } else {
    const isQtyDecimal = addToCart.isQtyDesimal;
    let newWeight = totalQtyFlag ? parseFloat(weight) : parseFloat(addedToCart[index].weight) + parseFloat(weight);
    let sendQty = parseFloat(addedToCart[index]?.sendQty || 0) + parseFloat(weight);
    if (groupChildFlag === false) {
      addedToCart[index].weight = newWeight;
      addToCart.weight = newWeight;
      addedToCart[index] = {
        ...addedToCart[index],
        sendQty: sendQty,
      };
    }

    if (parseFloat(addedToCart[index].weight) <= 0) {
      addedToCart.splice(index, 1);
      if (!isExchange) {
        setCart((prevCart) => {
          const updatedItems = prevCart.items.filter((cartItem) => cartItem?.lineId !== addedToCart?.[index]?.lineId);
          const updatedCart = { ...prevCart, addedToCart: updatedItems };
          return updatedCart;
        });
      }

      try {
        const tableData = await db.tableData.toArray();
        const updatedTableData = tableData.map((table) => {
          if (table.title === cart.tableNo) {
            return { ...table, items: [...cart.items] };
          }
          return table;
        });
        for (const updatedTable of updatedTableData) {
          if (updatedTable.title === cart.tableNo) {
            await db.tableData.put(updatedTable);
          }
        }
        setTableCards(updatedTableData);
      } catch (error) {
        console.error("Error updating table data:", error);
      }

      try {
        // Fetch all FB orders and filter in JS — closure-based .filter() breaks in SQLite/IPC mode
        const allFbOrders1 = await db.fbOrderData.toArray();
        const matchingOrder = allFbOrders1.find((order) => order.cart?.sOrderID === cart.sOrderID && order.table === cart.tableNo);

        if (matchingOrder) {
          const updatedOrder = {
            ...matchingOrder,
            cart: {
              ...matchingOrder.cart,
              items: [...cart.items],
            },
          };
          await db.fbOrderData.put(updatedOrder);
        }
      } catch (error) {
        console.error("Error updating fbOrderData:", error);
      }
    } else {
      let manualDiscountInput = 0;
      if (addedToCart[index].discountType === "PD") {
        manualDiscountInput = addedToCart[index].discountValue;
      }
      const discountAmt = (parseFloat(manualDiscountInput) / 100) * parseFloat(addedToCart[index].realPrice);
      addedToCart[index].discount = totalQtyFlag ? discountAmt * weight : discountAmt * addedToCart[index].weight;
      //const addOnsNewProduct = sumBy(addedToCart?.selectedAddons, "price");
      const addOnsPriceSum = sumBy(addedToCart[index]?.selectedAddons, "price");
      const sp = parseFloat(addedToCart[index].realPrice) + addOnsPriceSum - discountAmt;
      let mrp = totalQtyFlag ? parseFloat(sp) * weight : parseFloat(sp) * addedToCart[index].weight;
      const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart[index].taxRate / 100) : (mrp * addedToCart[index].taxRate) / 100;
      if (groupChildFlag === false && groupParentFlag === false) {
        const factor = Math.pow(10, precision);
        const qty = addedToCart[index].weight;
        const unitTax = taxIncludeFlag === "Y" ? sp - sp / (1 + addedToCart[index].taxRate / 100) : (sp * addedToCart[index].taxRate) / 100;

        const unitMrp = sp;
        const roundedUnitTax = Math.round((unitTax + Number.EPSILON) * factor) / factor;
        const roundedUnitMrp = Math.round((unitMrp + Number.EPSILON) * factor) / factor;

        addedToCart[index].taxAmount = taxIncludeFlag === "Y" ? parseFloat(parseFloat(tax).toFixed(precision)) : roundTo(tax, precision);
        addedToCart[index].nettotal =
          taxIncludeFlag === "Y"
            ? parseFloat(parseFloat(mrp).toFixed(precision))
            : // parseFloat(parseFloat(mrp + tax).toFixed(precision));
              roundTo(mrp + tax, precision);
      }
      addedToCart[index].modified = addToCart?.modified ? true : false;
      delete addedToCart[index].nextRule;
      if (addedToCart[index].discount <= 0) {
        delete addedToCart[index].priority;
      }
      deferredMsg = {
        type: qty < 0 ? "warning" : "success",
        text: `${addToCart.name} ${qty < 0 ? messages.errors.cart.removed_successfully : messages.errors.cart.added_successfully}`,
      };
      try {
        const tableData = await db.tableData.toArray();
        const updatedTableData = tableData.map((table) => {
          if (table.title === cart.tableNo) {
            return { ...table, items: [...cart.items] };
          }
          return table;
        });
        for (const updatedTable of updatedTableData) {
          if (updatedTable.title === cart.tableNo) {
            await db.tableData.put(updatedTable);
          }
        }
        setTableCards(updatedTableData);
      } catch (error) {
        console.error("Error updating table data:", error);
      }

      try {
        // Fetch all FB orders and filter in JS — closure-based .filter() breaks in SQLite/IPC mode
        const allFbOrders2 = await db.fbOrderData.toArray();
        const matchingOrder = allFbOrders2.find((order) => order.cart?.sOrderID === cart.sOrderID && order.table === cart.tableNo);

        if (matchingOrder) {
          const updatedItems = matchingOrder.cart.items.map((item) => {
            if (item.lineId === addedToCart[index].lineId) {
              return addedToCart[index]; // Update the modified item
            }
            return item;
          });
          const total = updatedItems.reduce((sum, item) => sum + item.nettotal, 0);
          const totalQty = updatedItems.reduce((sum, item) => sum + item.weight, 0);
          const tax = updatedItems.reduce((sum, item) => sum + item.taxAmount, 0);
          const updatedOrder = {
            ...matchingOrder,
            cart: {
              ...matchingOrder.cart,
              items: updatedItems,
              total: total,
              tax: tax,
              totalQty: totalQty,
            },
          };

          updatedOrder.totalAmount = updatedItems.reduce((sum, item) => sum + item.nettotal, 0);

          await db.fbOrderData.put(updatedOrder);
        }
      } catch (error) {
        console.error("Error updating fbOrderData:", error);
      }
    }
    }
  } else {
    // Create a shallow copy of addToCart to work with the updated item
    let newAddToCart = { ...addToCart };
    newAddToCart.saleType = useRestaurantStore.getState().dineIn === "Y" ? "DI" : "TA";
    const cartObj = useCartStore.getState().cart;
    if (receiptlessReturn2Enabled && activeCartFromStorage?.isReturn === true && activeCartFromStorage?.isBlindReceipt === true) {
      newAddToCart.weight = -Math.abs(weight);
    } else {
      newAddToCart.weight = parseFloat(truncateToPrecision(weight, newAddToCart.isQtyDesimal));
    }

    const addOnsPriceSum = sumBy(newAddToCart?.selectedAddons, "price") || 0;
    delete newAddToCart.nextRule;

    const mrp = modifiedPrice && newAddToCart.taxFlag === "N" ? modifiedPrice : (parseFloat(newAddToCart.salePrice) + addOnsPriceSum) * parseFloat(weight);

    const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + newAddToCart.taxRate / 100) : mrp * (newAddToCart.taxRate / 100);
    let netStd = parseFloat(newAddToCart.sunitprice - newAddToCart.sunitprice / (1 + newAddToCart.taxRate / 100));
    let netStdValue =
      taxIncludeFlag === "Y"
        ? newAddToCart.sunitprice > 0
          ? parseFloat(parseFloat(newAddToCart.sunitprice - netStd).toFixed(precision))
          : 0
        : roundTo(newAddToCart.sunitprice ?? 0, precision);
    newAddToCart.taxAmount = taxIncludeFlag === "Y" ? tax : roundTo(tax, precision);
    newAddToCart.nettotal =
      taxIncludeFlag === "Y"
        ? parseFloat(mrp - (newAddToCart.discount ? parseFloat(newAddToCart.discount) : 0))
        : roundTo(mrp - (newAddToCart.discount ? parseFloat(newAddToCart.discount) : 0) + tax, precision);

    newAddToCart.nettotal = taxIncludeFlag === "Y" ? parseFloat(parseFloat(newAddToCart.nettotal).toFixed(precision)) : roundTo(newAddToCart.nettotal, precision);
    newAddToCart.unitTax = newAddToCart?.isReturn
      ? newAddToCart.unitTax
      : taxIncludeFlag === "Y"
        ? parseFloat(parseFloat(newAddToCart.salePrice - newAddToCart.salePrice / (1 + newAddToCart.taxRate / 100)).toFixed(precision))
        : roundTo((newAddToCart.salePrice * newAddToCart.taxRate) / 100, precision);

    newAddToCart.netStd = isWalletReturn ? -Math.abs(netStdValue) : netStdValue;

    newAddToCart.lineId = uuidv4().replace(/-/g, "").toUpperCase();
    newAddToCart.salesRepId = salesRepresentDefaultLine.salesRepresentId;
    newAddToCart.salesRepName = Object.keys(salesRepresent).length > 0 ? salesRepresentDefaultLine.name : "";
    if (isWalletReturn) {
      newAddToCart.sunitprice = -Math.abs(newAddToCart.sunitprice);
      newAddToCart.listPrice = -Math.abs(newAddToCart.listPrice);
      newAddToCart.netStd = -Math.abs(newAddToCart.netStd);
      newAddToCart.unitTax = -Math.abs(newAddToCart.unitTax);
    }
    // Add the newly created item to the cart
    isNewLineAdded = true;
    addedToCart.unshift(newAddToCart);

    let latestIndex = 0; // Since we used unshift, the latest item is at index 0
    setSelectedRowKeys([latestIndex]);
    setSelectedProductInCart(newAddToCart);
    addToCart = { ...newAddToCart };
    deferredMsg = {
      type: qty < 0 ? "warning" : "success",
      text: `${newAddToCart.name} ${qty < 0 ? messages.errors.cart.removed_successfully : messages.errors.cart.added_successfully}`,
    };
    deferredPoleDisplay = newAddToCart;
  }
  // addedToCart = clubProductsWithAddOns(addedToCart, precision);
  let stockCheckResult = true;
  let isFinalValidation = false;
  let isCompleteSale = false;
  const isPreOrderPage = window.location.pathname.includes("/preorder");
  const hasChildItems = addedToCart?.some((item) => (Array.isArray(item.childItems) && item.childItems.length > 0) || (Array.isArray(item.children) && item.children.length > 0));

  if (hasChildItems && (totalQtyFlag || quantityChange)) {
    isCompleteSale = true;
  }
  // BUG-1640: block adding a product that has no resolvable price (removed from the
  // active price list in backoffice, comes back as isactive:true with priceList:null
  // and sunitprice/salePrice 0). posPriceEdit==="Y" items (e.g. BATTERY) are exempt —
  // those are meant to be manually priced by the cashier and legitimately have no
  // price-list entry. Scoped to the brand-new-line-add path only, same gate the
  // stock() check below already uses, so it never touches qty-increment/return/service/
  // layaway/offline flows.
  if (
    isNewLineAdded &&
    (addToCart.type === "I" || !addToCart.type) &&
    addToCart.layAway !== "Y" &&
    navigator.onLine &&
    !returnEnabled &&
    addToCart.posPriceEdit !== "Y" &&
    (!Array.isArray(addToCart.priceList) || addToCart.priceList.length === 0) &&
    !(Number(addToCart.sunitprice) > 0) &&
    !(Number(addToCart.salePrice) > 0) &&
    !(Number(addToCart.realPrice) > 0)
  ) {
    activeCartFromStorage.items = itemsSnapshot;
    setSelectedProductInCart({});
    if (isExchange) {
      useCartStore.getState().setExchangeCart({ ...activeCartFromStorage, items: itemsSnapshot });
    } else {
      setCart({ ...cart, items: itemsSnapshot });
    }
    Modal.info({
      icon: null,
      okText: "Ok",
      okButtonProps: { style: { display: "inline-block" } },
      content: (
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Not Found" style={{ width: "120px", height: "100px" }} />
          <p style={{ margin: "5px 0", fontSize: "1.5em", fontWeight: "600", color: "#0F0718" }}>{addToCart.value}</p>
          <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Product Not Found</p>
          <hr style={{ width: "70%", color: "rgba(146,144,152,0.5" }} />
          <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "15px 15px 0 15px" }}>
            This product is not available for sale. Please check the price list configuration.
          </p>
        </div>
      ),
      style: {
        textAlign: "center",
        height: "50vh",
        width: "50%",
      },
      closable: false,
    });
    return;
  }
  if (
    (addToCart.type === "I" || !addToCart.type) &&
    addToCart.layAway !== "Y" &&
    // addToCart.productSegment !== "CB" &&
    navigator.onLine &&
    // cart.layAway !== "Y" &&
    tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y" &&
    !deleteProductInCart &&
    !isPreOrderPage &&
    !returnEnabled
  ) {
    stockCheckResult = await stock({
      cart: { ...cart, items: addedToCart },
      setCart,
      tillData,
      setProductStock,
      isFinalValidation,
      setCart,
      isCompleteSale,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      customMixHandler: false,
      setProductBOMStock,
      setProductBOMStockData,
    });
    if (!stockCheckResult) {
      activeCartFromStorage.items = itemsSnapshot;
      setSelectedProductInCart({});
      if (isExchange) {
        useCartStore.getState().setExchangeCart({ ...activeCartFromStorage, items: itemsSnapshot });
      } else {
        setCart({ ...cart, items: itemsSnapshot });
      }
      return;
    }
  }

  if (deferredMsg) {
    message[deferredMsg.type](deferredMsg.text, 0.1);
  }
  if (deferredPoleDisplay) {
    if (CWHardwareController) {
      CWPoleDisplay(deferredPoleDisplay, "Add item to cart");
    } else {
      PoleDisplay(deferredPoleDisplay, "Add item to cart");
    }
  }

  let totalTax = 0;
  let totalPrice = 0;
  let totalItemsQty = 0;
  let totalDiscounts = 0;
  for (let i = 0; i < addedToCart.length; i += 1) {
    if (addedToCart[i]?.isCanceled === "Y") {
      continue;
    }
    totalPrice += parseFloat(parseFloat(addedToCart[i].nettotal).toFixed(precision));
    totalItemsQty += addedToCart[i].weight;
    totalTax += parseFloat(parseFloat(addedToCart[i].taxAmount).toFixed(precision));
    totalDiscounts += parseFloat(parseFloat(addedToCart[i].discount).toFixed(precision));
    addedToCart[i].key = i;
  }

  const { roundedTotal: roundOffValue, roundOffAmount: totalRoundOff } = applyCurrencyRounding(totalPrice, getRoundingMethod(tillData));
  const isExchangeFlag = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  if (cart.items.length === 0 && !isExchangeFlag) {
    deleteCart(null, null, isExchangeFlag);
  }
  let cartObj = {
    // ...cart,
    ...activeCartFromStorage,
    items: [...addedToCart],
    total: roundOffValue,
    tax: totalTax,
    discount: totalDiscounts,
    totalQty: totalItemsQty,
    roundOff: totalRoundOff,
  };

  if (cartObj.items.length === 0 && tillData.tillAccess.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && cartObj.description !== "") {
    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    orderTimeDetails = {
      ...orderTimeDetails,
      orderStartTime: "", // Update orderStartTime to current time
    };
    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
  }

  let updatedCart = cartObj;

  if (cartObj.items?.length > 0) {
    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    orderTimeDetails = {
      ...orderTimeDetails,
      paymentStartTime: "",
      orderStartTime: orderTimeDetails.orderStartTime !== "" ? orderTimeDetails.orderStartTime : dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
    };
    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
    updatedCart = addedToCart.isReturn ? cartObj : await pricingRuleController(addToCart, cartObj, cart, setCart, cartRef, orderType);
  }

  if (updatedCart?.couponInput?.length > 0 && cart?.statusType !== "layAway") {
    // Use sequential for...of instead of Promise.all map — parallel execution causes
    // updatedCart reassignments to race and overwrite each other (stale closure).
    for (const coupon of updatedCart.couponInput) {
      updatedCart = await pricingRuleController(
        addToCart,
        updatedCart,
        cart,
        setCart,
        cartRef,
        orderType,
        true,
        coupon.couponCode,
        coupon.referenceId,
        coupon.mPricingCouponId,
        coupon.mPricingruleId
      );
    }
  }

  const allDiscounts = [...(updatedCart?.manualDiscountData?.lineLevelDiscount || []), ...(updatedCart?.manualDiscountData?.totalLevelDiscount || [])].sort(
    (a, b) => a.sequenceNo - b.sequenceNo
  );

  const uniqueDiscounts = allDiscounts.reduce((acc, item) => {
    if (!acc.some((discount) => discount.pricingRule === item.pricingRule)) {
      acc.push(item);
    }
    return acc;
  }, []);

  uniqueDiscounts.forEach(async (item) => {
    const pricingRule = manualDiscountTypes.find((md) => md.mPricingrulesId === item.pricingRule);

    if (pricingRule) {
      if (pricingRule.type === "FD" || pricingRule.type === "PD") {
        updatedCart.items.forEach(async (cartItem) => {
          const isLineLevelDiscount = updatedCart?.manualDiscountData?.lineLevelDiscount?.some((d) => d.pricingRule === item.pricingRule);
          let allDiscounts = cartItem?.allDiscounts || [];
          let matchedRuleIndex = allDiscounts.findIndex((d) => d.mPricingruleId === pricingRule.mPricingrulesId);
          if (isLineLevelDiscount && matchedRuleIndex !== -1) {
            const applyDiscount = pricingRule.type === "FD" ? CheckoutFlatDiscount : CheckoutPercentageDiscount;
            cartItem.priority = 0;
            updatedCart = await applyDiscount(cartItem, pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
          }
        });
      }

      if (pricingRule.type === "TD") {
        await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
      }
    }
  });

  // Use updatedCart (post-pricingRuleController) not stale cart/cartObj.
  // Also carry over couponInput discount type override so amount coupons re-apply correctly.
  const activeTotalBillDicount = updatedCart?.totalBillDicount || cart.totalBillDicount;
  if (activeTotalBillDicount) {
    const matchingPricingRules = findPricingRuleById(activeTotalBillDicount);
    if (matchingPricingRules.length > 0) {
      const ruleToApply = { ...matchingPricingRules[0] };
      // Re-apply the discountType override from couponInput so amount coupons use "V" not their DB value.
      const matchedCoupon = (updatedCart?.couponInput || cart?.couponInput || []).find((c) => c.mPricingruleId === ruleToApply.mPricingrulesId);
      if (matchedCoupon?.discountType) {
        ruleToApply.discountType = matchedCoupon.discountType;
        ruleToApply.amountDiscount = matchedCoupon.amountDiscount ?? ruleToApply.amountDiscount;
        ruleToApply.percentageDiscount = matchedCoupon.percentageDiscount ?? ruleToApply.percentageDiscount;
      }
      await processBillDiscounts(ruleToApply, updatedCart, true);
      updatedCart = useCartStore.getState().cart;
    }
  }

  if (cart.manualDiscountApplied && cart.manualDiscountApplied !== 0 && cart.discountType === "TD") {
    setLoader(true);
    setTimeout(async () => {
      await processTotalManualDiscount(cart.manualDiscountApplied);
      setLoader(false);
    }, 200);
  }

  const layout = userAccessController.layout;
  if (layout === "2") {
    const cartData = cartObj ? { ...cartObj } : cart;
    if (cart?.items?.length > 0) {
      const pricingRules = getPricingRules();
      pricingRules.map(async (pr) => {
        const pricingRuleCount = pr.length;
        if (pricingRuleCount > 0) {
          pr.sort((a, b) => {
            if (a.priority === null && b.priority === null) {
              return 0;
            } else if (a.priority === null) {
              return 1;
            } else if (b.priority === null) {
              return -1;
            }
            return parseInt(a.priority, 10) - parseInt(b.priority, 10);
          });
          for (let i = 0; i < pricingRuleCount; i++) {
            const pricingRule = pr[i];
            if (dateValidator(pricingRule.startDate, pricingRule.endDate) && pricingRule.iscoupon === "N" && (pricingRule.type === "TD" || pricingRule.type === "TDF")) {
              // Skip non-coupon TD rules if the cart already has an active coupon applied.
              // Running them would overwrite the coupon discount on cart items.
              const cartHasCoupon = cartData.iscoupon === true || cartData.couponInput?.length > 0 || cartData.items?.some((item) => item.iscoupon === true);
              if (cartHasCoupon) continue;
              if (pricingRule.timeSpecific === "Y") {
                const weekDay = currentDay();
                const pStartTime = pricingRule.starttime.substring(11);
                const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
                const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
                const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
                if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
                  updatedCart = await processBillDiscounts(pricingRule, cartData, false);
                }
              } else {
                updatedCart = await processBillDiscounts(pricingRule, cartData, false);
              }
            }
          }
        }
      });
    }
  }

  const itemSummery = {
    decimalItems: { totalQty: 0, totalAmount: 0 },
    nonDecimalItems: { totalQty: 0, totalAmount: 0 },
    itemsQty: 0,
    items: 0,
  };

  // Group items by tax rate
  // const groupedItems = (updatedCart.items || []).reduce((acc, item) => {
  //   const key = item.tax?.rate ?? item.taxRate ?? "0";
  //   acc[key] = acc[key] || [];
  //   acc[key].push(item);
  //   return acc;
  // }, {});

  const isInterState = getIsInterState(updatedCart);
  const groupedItemsByTaxRate = groupItemsByTaxRate(updatedCart.items, precision, { isInterState });

  let updatedTotalTax = 0;
  let updatedTotalPrice = 0;
  let updatedTotalItemsQty = 0;
  let updatedTotalDiscounts = 0;
  updatedCart.items = updatedCart.items.map((item, i) => {
    if (item?.isCanceled === "Y") {
      return item;
    }
    const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
    const nettotalFixed = item.nettotal;
    const taxAmountFixed = parseFloat(parseFloat(item.taxAmount).toFixed(precision));
    // const discountFixed = item.discount ? parseFloat(truncateToPrecision(item.discount, precision)) : 0;
    const discountFixed = item.discount ? parseFloat(parseFloat(item.discount).toFixed(precision)) : 0;

    // Update totals
    updatedTotalPrice += nettotalFixed;
    updatedTotalItemsQty += parseFloat(parseFloat(item.weight).toFixed(precision));
    updatedTotalTax += taxAmountFixed;
    updatedTotalDiscounts += discountFixed;

    item.discount = discountFixed;
    item.key = i;

    if (!item.isGiftCard) {
      const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
      const lineTax = roundTo(item.listPrice * (1 + item.taxRate / 100), precision);
      const stdTax = roundTo(item.sunitprice * (1 + item.taxRate / 100), precision);
      // const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
      const netList =
        taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100)).toFixed(precision)) : item.listPrice;
      const gross_list =
        taxIncludeFlag === "Y"
          ? item.listPrice
          : // parseFloat(parseFloat(lineTax).toFixed(precision));
            roundTo(lineTax, precision);
      // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax).toFixed(precision));
      const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : roundTo(stdTax, precision);
      // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;
      const isWalletReturn = receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true;
      Object.assign(item, {
        linetax: nettotalFixed ? taxAmountFixed : 0,
        linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount).toFixed(precision)) : 0,
        linegross: nettotalFixed ? (isWalletReturn ? Math.abs(nettotalFixed) : nettotalFixed) : 0,
        linestd: nettotalFixed ? parseFloat(parseFloat(isWalletReturn ? Math.abs(grossStd * item.weight) : grossStd * item.weight).toFixed(precision)) : 0,
        netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
        listprice: nettotalFixed ? (isWalletReturn ? -Math.abs(item.listPrice) : item.listPrice) : 0,
        grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) * (isWalletReturn ? 1 : item.isReturn ? -1 : 1) : 0,
        grossstd: nettotalFixed ? parseFloat(parseFloat(grossStd).toFixed(precision)) : 0,
        grosslist: nettotalFixed ? gross_list : 0,
        netList: nettotalFixed ? (isWalletReturn ? Math.abs(netList) : netList) : 0,
        unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
        taxAmount: nettotalFixed ? taxAmountFixed : 0,
      });
    }
    // Update summary
    // const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
    // const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
    // itemSummery.itemsQty += item.weight;
    // itemSummery.items += 1;
    // itemSummery[summaryKey].totalQty += item.weight;
    // itemSummery[summaryKey].totalAmount += parseFloat(truncateToPrecision(item.nettotal, precision));

    if (Array.isArray(item.children) && item.children.length > 0) {
      item.children.forEach((child) => {
        const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += child.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += child.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal).toFixed(precision));
      });
    } else {
      const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
      const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

      itemSummery.itemsQty += item.weight;
      itemSummery.items += 1;
      itemSummery[summaryKey].totalQty += item.weight;
      itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal).toFixed(precision));
    }

    return item;
  });
  const calculateRoundingDifference = (value) => {
    const { roundOffAmount } = applyCurrencyRounding(value, getRoundingMethod(tillData));
    return parseFloat(parseFloat(roundOffAmount).toFixed(precision));
  };
  index = updatedCart?.items.findIndex((p) => p.productId === addToCart.productId && (p.upc || "") === (addToCart.upc || ""));
  // if (index !== -1 && addToCart.addNewLine !== "Y") {
  //   // Remove the item from its current position
  //   const removedItem = updatedCart?.items.splice(index, 1)[0];

  //   // Place the item at the beginning of the array
  //   updatedCart?.items.unshift(removedItem);
  // }

  if (index !== -1 && addToCart.addNewLine !== "Y") {
    const layout = userAccessController.layout;
    if (layout === "3" || addedToCart[index]?.children || addedToCart[index]?.children?.length > 0) {
      updatedCart.items[index].quantity += addToCart.quantity;
      // updatedCart.items[index].weight += addToCart.weight;
    } else {
      const removedItem = updatedCart?.items.splice(index, 1)[0];

      // Place the item at the beginning of the array
      updatedCart?.items.unshift(removedItem);
    }
  }
  const { roundedTotal: updatedRoundedTotal, roundOffAmount: updatedTotalRoundOffAmount } = applyCurrencyRounding(updatedTotalPrice, getRoundingMethod(tillData));
  const updatedTotalRoundOff = parseFloat(parseFloat(updatedTotalRoundOffAmount).toFixed(precision));
  // Sum Line Totals
  const sumLineTotals = (lines) => {
    let totalLineGross = 0;
    let totalLineTax = 0;

    lines.forEach((line) => {
      totalLineGross += line.nettotal;
      totalLineTax += line.taxAmount;
    });

    return { totalLineGross, totalLineTax };
  };
  // Compare and Adjust Order Totals

  const adjustOrderTotals = (order, lines) => {
    const { totalLineGross, totalLineTax } = sumLineTotals(lines);
    let adjustedOrderGross = order.total;
    let adjustedOrderTax = order.tax;

    const grossDifference = totalLineGross - adjustedOrderGross;
    const taxDifference = totalLineTax - adjustedOrderTax;

    // If grossDifference equals the existing roundOff, the gap is due to intentional
    // currency rounding — preserve the rounded total instead of correcting it back.
    // grossDifference = gross - rounded; roundOff = rounded - gross; sum = 0 when equal.
    const existingRoundOff = order.roundOff || 0;
    const isRoundingDifference = Math.abs(grossDifference + existingRoundOff) < 0.01;

    if (Math.abs(grossDifference) > 0.01 && !isRoundingDifference) {
      adjustedOrderGross += grossDifference;
    }

    if (Math.abs(taxDifference) > 0.01) {
      adjustedOrderTax += taxDifference;
    }

    return {
      ...order,
      total: adjustedOrderGross,
      tax: adjustedOrderTax,
    };
  };
  updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
  // const updatedTotalStd = updatedCart.items.reduce((sum, item) => sum + item.linestd, 0);
  const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
  const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
  const items = [...updatedCart?.items];
  let totalTaxItems = 0;
  for (let i = 0; i < items.length; i += 1) {
    totalTaxItems += items[i].taxAmount;
  }
  let finalCartObj = {
    ...updatedCart,
    layAway: layAwayFlag,
    items: [...updatedCart?.items],
    discount: updatedTotalDiscounts,
    totalQty: parseFloat(updatedTotalItemsQty.toFixed(precision)),
    roundOff: updatedTotalRoundOff,
    total: updatedRoundedTotal,
    tax: totalTaxItems,
    payments: updatedCart?.items.length > 0 ? updatedCart.payments : [],
    paid: updatedCart?.items.length > 0 ? updatedCart.paid : 0,
    subTotal: parseFloat(parseFloat(updatedTotalPrice - totalTaxItems).toFixed(precision)),
    amountInWords: numberToWords(updatedRoundedTotal),
    itemsSummery: itemSummery,
    groupedItemsByTaxRate,
    saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype || {},
    totalStd: updatedTotalStd,
  };
  // Sync selectedProductInCart with the post-pricing-rule item so that the
  // next '+'/'-' press sees the discountName/discountType that pricing rules
  // (e.g. BuyXPayYOfSame / BUY 1 GET 1) just stamped on the cart item.
  // Without this, findIndex checks !p.discountName and misses the item,
  // causing a spurious new cart line to be created on rapid '+' presses.
  const updatedSelectedItem = updatedCart?.items?.find((item) => item.lineId === addToCart.lineId);
  setSelectedProductInCart(updatedSelectedItem || addToCart);
  const addToCartIdx = addedToCart.findIndex((item) => item.productId === addToCart.productId);
  if (addToCartIdx >= 0) setSelectedRowKeys([addToCartIdx]);
  if (returnThisReceipt === "true" && selectedReturnType === "STORE_CREDIT") {
    localStorage.setItem("selectedReturnType", "STORE_CREDIT");
    useTransactionStore.getState().setSelectedReturnType("STORE_CREDIT");
    const walletPayment = tillData.tillAccess.csBunit.paymentMethodList.find((pm) => pm.isWallet === "Y");
    if (walletPayment) {
      setSelectedPaymentMethod(walletPayment);
    }
  }
  if (isExchange && !returnThisReceipt) {
    const returnCartObj = useCartStore.getState().cart;
    const finalExchangeCart = { ...finalCartObj, returnsOrderId: returnCartObj?.sOrderID || null };
    useCartStore.getState().setExchangeCart(finalExchangeCart);
  } else {
    setCart(finalCartObj);
  }
  if (posConfig?.saveParkedBills === "Y" && finalCartObj?.isRetrived === "Y") {
    setManualDiscountInput(null);
    setSelectedManualDiscountTypeValue(null);
  }
  useTransactionStore.getState().setReturnThisReceipt(null);
};
